import TextOptions from "%/dynamic-components/render-engine/bundles/text-options";
import { mapActions, mapWritableState } from "pinia";
import useDynamicComponentBuilderStore from "%/stores/dynamic-component-builder-store";
import TextOption from "%/dynamic-components/render-engine/options/text-options/text-option";
import TextWrap from "%/dynamic-components/render-engine/options/text-options/text-wrap";
import HrefOption from "%/dynamic-components/render-engine/options/url-options/href-option";
import TextAlign from "%/dynamic-components/render-engine/options/text-options/text-align";
import Ellipsis from "%/dynamic-components/render-engine/options/text-options/ellipsis";
import TextDecoration from "%/dynamic-components/render-engine/options/text-options/text-decoration";
import Padding from "%/dynamic-components/render-engine/options/spacing-options/padding";
import Margins from "%/dynamic-components/render-engine/options/spacing-options/margins";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import FontFamily from "%/dynamic-components/render-engine/options/text-options/font-family";
import FontSize from "%/dynamic-components/render-engine/options/text-options/font-size";
import FontColor from "%/dynamic-components/render-engine/options/text-options/font-color";
import normalizeFontSizeStyleValue from "%/dynamic-component-editor/helpers/font-size-style-value";
import FontWeight from "%/dynamic-components/render-engine/options/text-options/font-weight";
import FontCase from "%/dynamic-components/render-engine/options/text-options/font-case";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import FontStyle from "%/dynamic-components/render-engine/options/text-options/font-style";
import LineHeightMultiplier from "%/dynamic-components/render-engine/options/text-options/line-height-multiplier";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import BasicTextOptions from "%/dynamic-components/render-engine/bundles/basic-text-options";
import BackgroundColor from "%/dynamic-components/render-engine/options/background-options/background-color";
import BackgroundOptions from "%/dynamic-components/render-engine/bundles/background-options";
import Label from "%/dynamic-components/render-engine/options/url-options/label";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import TextOverflow from "%/dynamic-components/render-engine/options/text-options/text-overflow";
import MaxVerticalLines from "%/dynamic-components/render-engine/options/text-options/max-vertical-lines";
import ClickAction from "%/dynamic-components/render-engine/options/click-actions/click-action";
import TypographyBranding from "%/dynamic-components/render-engine/classes/branding/typography-branding";

const CLICK_BUFFER = 1000;

// FOR NOW BECAUSE OF THE MIXIN INHERITANCE I NEED TO CREATE DUPLICATES TO REMOVE CERTAIN
// BUNDLE OPTIONS FROM ELEMENTS
export const TextWithoutBrandingElementMixin = {
  elementPanelSettings: {
    displayIcon: "text",
    elementType: "element",
    elementGroup: "general",
  },
  brandingType: TypographyBranding,
  optionBundles: [
    AppearanceOptions,
    BasicTextOptions,
    TextOptions,
    new SpacingOptions({
      "default.padding": {
        "top": null,
        "left": null,
        "bottom": null,
        "right": null,
      },
    }),
    new BackgroundOptions({}, {
      "background-image": true,
    }),
    EffectsOptions,
  ],
  options: [
    ClickAction,
  ],
  data() {
    return {
      initialValue: "",
      TextOption,
      TextWrap,
      TextAlign,
      Ellipsis,
      FontCase,
      HrefOption,
      lastClicked: 0,
      editable: false,
      relatedElement: null,
      debounce: null,
      showLinkModal: false,
      linkData: {},
      originalLinkData: {},
    };
  },
  computed: {
    ...mapWritableState(useDynamicComponentBuilderStore, [
      "currentlyInspectedElementIdentifiers",
      "dynamicComponentName",
      "isPage",
    ]),
    fontColor() {
      return this.getOptionValue(FontColor);
    },
    fontSizeNumberValue() {
      return parseInt(this.getOptionValue(FontSize).replace("px", ""));
    },
    fullTextOptionsAttributes() {
      return {
        width: this.myWidth,
        ...this.textOnlyAttributes,
        textStyleOverrides: this.textStyleOverrides,
      };
    },
    textOnlyAttributes() {
      return {
        maxVerticalLines: this.getOptionValue(MaxVerticalLines),
        overflow: this.getOptionValue(TextOverflow),
        wrap: this.getOptionValue(TextWrap),
        textAlign: this.getOptionValue(TextAlign),
        textCase: this.getOptionValue(FontCase),
        lineHeightMultiplier: this.getOptionValue(LineHeightMultiplier),
        textStyleOverrides: this.textOnlyStyleOverrides,
      };
    },
    textOnlyStyleOverrides() {
      return {
        standardFontFamily: this.getOptionValue(FontFamily),
        standardFontSize: normalizeFontSizeStyleValue(this.getOptionValue(FontSize), { element: "TextElement", option: "font-size" }),
        standardFontColor: this.getOptionValue(FontColor) || "standard",
        standardFontWeight: this.getOptionValue(FontWeight),
        standardHoverFontFamily: this.getOptionValue(FontFamily, BaseOption.$states.HOVER),
        standardHoverFontSize: normalizeFontSizeStyleValue(this.getOptionValue(FontSize, BaseOption.$states.HOVER), { element: "TextElement", option: "hover.font-size" }),
        standardHoverFontColor: this.getOptionValue(FontColor, BaseOption.$states.HOVER) || "standard",
        standardHoverFontWeight: this.getOptionValue(FontWeight, BaseOption.$states.HOVER),
        textDecoration: this.getOptionValue(TextDecoration),
        textDecorationHover: this.getOptionValue(TextDecoration, BaseOption.$states.HOVER),
        textStyle: this.getOptionValue(FontStyle),
        textStyleHover: this.getOptionValue(FontStyle, BaseOption.$states.HOVER),
      };
    },
    spacingStyleOverrides() {
      return {
        paddingTop: this.getOptionValue(Padding, BaseOption.$states.DEFAULT, "top") || "none",
        paddingBottom: this.getOptionValue(Padding, BaseOption.$states.DEFAULT, "bottom") || "none",
        paddingLeft: this.getOptionValue(Padding, BaseOption.$states.DEFAULT, "left") || "none",
        paddingRight: this.getOptionValue(Padding, BaseOption.$states.DEFAULT, "right") || "none",
        marginTop: this.getOptionValue(Margins, BaseOption.$states.DEFAULT, "top") || "none",
        marginBottom: this.getOptionValue(Margins, BaseOption.$states.DEFAULT, "bottom") || "none",
        marginLeft: this.getOptionValue(Margins, BaseOption.$states.DEFAULT, "left") || "none",
        marginRight: this.getOptionValue(Margins, BaseOption.$states.DEFAULT, "right") || "none",
        // paddingHoverTop: this.getOptionValue(Padding, BaseOption.$states.HOVER, "top") || "none",
        // paddingHoverBottom: this.getOptionValue(Padding, BaseOption.$states.HOVER, "bottom") || "none",
        // paddingHoverLeft: this.getOptionValue(Padding, BaseOption.$states.HOVER, "left") || "none",
        // paddingHoverRight: this.getOptionValue(Padding, BaseOption.$states.HOVER, "right") || "none",
        // marginHoverTop: this.getOptionValue(Margins, BaseOption.$states.HOVER, "top") || "none",
        // marginHoverBottom: this.getOptionValue(Margins, BaseOption.$states.HOVER, "bottom") || "none",
        // marginHoverLeft: this.getOptionValue(Margins, BaseOption.$states.HOVER, "left") || "none",
        // marginHoverRight: this.getOptionValue(Margins, BaseOption.$states.HOVER, "right") || "none",
      };
    },
    textStyleOverrides() {
      return {
        standardFontFamily: this.getOptionValue(FontFamily),
        standardFontSize: normalizeFontSizeStyleValue(this.getOptionValue(FontSize), { element: "TextElement", option: "font-size" }),
        standardFontColor: this.getOptionValue(FontColor),
        standardFontWeight: this.getOptionValue(FontWeight),
        standardHoverFontFamily: this.getOptionValue(FontFamily, BaseOption.$states.HOVER),
        standardHoverFontSize: normalizeFontSizeStyleValue(this.getOptionValue(FontSize, BaseOption.$states.HOVER), { element: "TextElement", option: "hover.font-size" }),
        standardHoverFontColor: this.getOptionValue(FontColor, BaseOption.$states.HOVER),
        standardHoverFontWeight: this.getOptionValue(FontWeight, BaseOption.$states.HOVER),
        ...this.spacingStyleOverrides,
        backgroundColor: this.getOptionValue(BackgroundColor),
        textDecoration: this.getOptionValue(TextDecoration),
        textDecorationHover: this.getOptionValue(TextDecoration, BaseOption.$states.HOVER),
        textStyle: this.getOptionValue(FontStyle),
        textStyleHover: this.getOptionValue(FontStyle, BaseOption.$states.HOVER),
        hoverBackgroundColor: this.getOptionValue(BackgroundColor, BaseOption.$states.HOVER),
      };
    },
    textIsEmpty() {
      return this.initialValue.body_text === "\n" || !this.initialValue.body_text;
    },
    textOptionValue() {
      let textValue = this.getOptionValue(this.textValueOptionClass) || "";
      if (this.textValueKey && textValue) {
        // handle backwards compat
        if (this.textValueKey === "label") {
          if (!textValue.hasUpdated) {
            textValue = this.getOptionValue(Label);
          } else {
            textValue = textValue[this.textValueKey];
          }
        } else {
          textValue = textValue[this.textValueKey];
        }
      }

      return textValue;
    },
    previewMode() {
      return !this.editable || !this.currentlyInspectedElementIdentifiers.includes(this.identifier);
    },
    hasTextContent() {
      if (!this.initialValue) {
        return false;
      }
      if (typeof this.initialValue === "string") {
        return this.initialValue.length > 0;
      }
      return this.initialValue.body_text.length > 0 && this.initialValue.body_text !== "\n";
    },
    changeListMessage() {
      let message = `Element text value updated for ${this.dynamicComponentName}`;
      if (this.isPage) {
        message = `Element text value updated for the ${this.dynamicComponentName}`;
      }
      return message;
    },
    textValueOptionClass() {
      return TextOption;
    },
    textValueKey() {
      return undefined;
    },
  },
  watch: {
    textOptionValue: {
      immediate: true,
      handler(newValue) {
        this.initialValue = newValue;
      },
    },
    previewMode(newValue) {
      if (newValue) {
        this.$refs.richTextElement.commands.closeBubbleMenu();
        useDynamicComponentBuilderStore().removeElementFromEditingInline(this.identifier);
      }
    },
  },
  created() {
    // this.setDefaultBrandingValue();
  },
  methods: {
    ...mapActions(useDynamicComponentBuilderStore, [
      "findElementInLayout",
      "handleOnEdit",
    ]),
    handleLinkModalOpen(event) {
      this.linkData = event;
      this.originalLinkData = event;
      this.showLinkModal = true;
    },
    handleLinkModalClose() {
      this.linkData = {};
      this.originalLinkData = {};
      this.showLinkModal = false;
    },
    setDefaultBrandingValue() {
      if (!this.configuration.options["default.text-branding-style-option"]) {
        this.configuration.options["default.text-branding-style-option"] = "paragraph";
      }
    },
    handleBlur() {
      this.editable = false;
    },
    handleEnter(event) {
      if (event.shiftKey) {
        this.handleBlur();
      }
    },
    handleClick(event) {
      if (this.editMode) {
        this.setElementToInspect(event);
        if (Date.now() - this.lastClicked < CLICK_BUFFER && !this.editable) {
          this.editable = true;
          this.relatedElement = { ...this.dynamicComponentInstance.getElementById(this.identifier) };
          useDynamicComponentBuilderStore().setElementAsEditingInline(this.identifier);
          requestAnimationFrame(() => {
            const editableContent = this.$el.querySelector(".i-text.editor-content");
            if (editableContent) {
              editableContent.focus();

              const range = document.createRange();
              range.selectNodeContents(editableContent);

              const selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
            }
          });
        }
        this.lastClicked = Date.now();
      }
    },
    setElementToInspect(event) {
      event.stopPropagation();
      this.handleOnEdit(this.identifier, event);
      useDynamicComponentBuilderStore().setActiveBreakpointByAlias(this.breakpoint);
    },
    handleTextOptionUpdate(value) {
      if (this.editMode) {
        this.initialValue = value;

        let valueToUpdate = value;

        if (this.textValueKey) {
          valueToUpdate = JSON.parse(JSON.stringify(this.getOptionValue(this.textValueOptionClass)));
          valueToUpdate[this.textValueKey] = value;
          valueToUpdate["hasUpdated"] = true;
        }
        const [state, breakpoint] = useDynamicComponentBuilderStore().activeState.split(":");

        this.dynamicComponentInstance.modifyElementOption(
          this.identifier,
          "text-option",
          valueToUpdate,
          breakpoint,
          state,
        );
      }
    },
  },
};
